/* Additive HRT controls. Reuses the existing theme's initialized Boulevard loader. */
(() => {
  if (window.omniHrtInstalled) return;
  window.omniHrtInstalled = true;
  const services = {
    hrt: '/cart/menu/Hormone%20Replacement%20Therapy/s_d49a8adc-bc94-4633-a64d-037fb7ac01f9',
    weight: '/cart/menu/Hormone%20Replacement%20Therapy/s_086b344f-166b-450e-b1cb-4475fa3ad343'
  };
  let opening = false;
  const wait = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  function initFaqs(root = document) {
    root.querySelectorAll('[data-hrt-faqs]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const items = [...group.querySelectorAll('[data-hrt-faq]')];
      const initial = Number(group.dataset.initial) || 5;
      const toggle = group.querySelector('[data-hrt-faq-toggle]');
      const extras = items.slice(initial);
      if (!extras.length || !toggle) return;
      extras.forEach(item => { item.hidden = true; });
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const expand = toggle.getAttribute('aria-expanded') !== 'true';
        extras.forEach(item => { item.hidden = !expand; });
        toggle.setAttribute('aria-expanded', String(expand));
        toggle.textContent = expand ? toggle.dataset.less : toggle.dataset.more;
      });
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-hrt-book]');
    if (!button) return;
    event.preventDefault();
    if (opening) return;
    const path = services[button.dataset.hrtBook];
    if (!path) return;
    opening = true;
    const status = button.closest('.hrt-booking').querySelector('.hrt-booking-status');
    button.setAttribute('aria-busy','true');
    status.hidden = false;
    status.textContent = 'Opening your consultation booking...';
    try {
      for (let attempt = 0; attempt < 40; attempt++) {
        if (window.blvd && typeof window.blvd.openBookingWidget === 'function') break;
        await wait(250);
        if (!button.isConnected) return;
      }
      if (!window.blvd || typeof window.blvd.openBookingWidget !== 'function') throw new Error('Boulevard unavailable');
      await window.blvd.openBookingWidget({urlParams: {
        locationId: '4f404d0e-4624-4888-a222-e1a83e71d4ba', path, visitType: 'SELF_VISIT'
      }});
      status.hidden = true;
    } catch (error) {
      status.textContent = 'Booking could not open. Please try again or call ';
      const phone = document.createElement('a');
      phone.href = 'tel:+17203131510';phone.textContent = '(720) 313-1510';
      status.appendChild(phone);
      status.appendChild(document.createTextNode('.'));
    } finally {
      button.removeAttribute('aria-busy');
      opening = false;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFaqs());
  else initFaqs();
  document.addEventListener('shopify:section:load', event => initFaqs(event.target));
  document.addEventListener('shopify:block:select', event => {
    if (event.target.matches('[data-hrt-faq]')) { event.target.hidden = false; event.target.open = true; }
  });
})();
